export const OFFER_TARIFF_ELEMENT = document.getElementById('offerTariff');

export const changeOfferTariff = (newValue) => {
    const offerTariffElements = document.querySelectorAll('[data-tariff="offer"]');

    offerTariffElements?.forEach(e => e.innerHTML = newValue)
}
